<template>
  <div
    class="tw-mx-auto"
    :class="{
      'tw-max-w-screen-sm': size === S.Tiny,
      'tw-max-w-screen-md': size === S.Medium,
      'tw-max-w-screen-xl': size === S.Large,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Size from '../interfaces/Size';

export default defineComponent({
  props: {
    size: {
      type: Number,
      default: Size.Large,
    },
  },
  data() {
    return {
      S: Size,
    };
  },
});
</script>
